module.exports = {
	"1": "1",
	"2": "2",
	"3": "3",
	"4": "4",
	"5": "5",
	"72": "72",
	"300": "300",
	"ImageResize": {
		"PageTitle": "Image Resizer to Resize and Crop Images Online for Free",
		"PageDescription": "Free image resizer to crop and resize images online. Resize images to an exact pixel size, file size in KB, or as a percentage of the original. Also supports photo manipulations such as flip and rotate.",
		"PageHeader": "Online Image Resizer - Crop and Resize Images",
		"PageHeaderDescription": "Crop, resize, flip, or rotate an image by uploading it below.",
		"Part1FirstH2": "What is ImageResize.org?",
		"Part1FirstP": "Imageresize.org is a simple online image resizer. This tool allows you to resize your photos to an exact dimension in pixels or as a percentage of your original photo. To start, simply upload an image using the upload box above. We currently support the following image editing functions: Image resize, crop, rotate, and flip.",
		"FAQ": "FAQ:",
		"FaqQuestion1": "Question: How to resize an image in pixels?",
		"FaqQ1Ans1": "Step 1: Upload your image",
		"FaqQ1Ans2": "Step 2: Select \"Custom Size\" from the drop-down box in \"Resize your Image\" section",
		"FaqQ1Ans3": "Step 3: Enter a new custom size for the image in pixels",
		"FaqQuestion2": "Question: How to reduce image size in kb?",
		"FaqQ2Ans1": "Step 1: Upload your image",
		"FaqQ2Ans2": "Step 2: Select \"Custom File Size\" from the \"Quality and Format\" section",
		"FaqQ2Ans3": "Enter a new target file size for your images in Kb or Mb",
		"FaqQuestion3": "Question: How to crop a photo?",
		"FaqQ3Ans1": "Step 1: Upload your photo",
		"FaqQ3Ans2": "Step 2: Click on the \"Crop\" icon under  \"Adjust Image\" section",
		"FaqQ3Ans3": "Step 3: Optionally, select an aspect ratio or lock the original aspect ratio from the crop tool panel",
		"FaqQ3Ans4": "Step 4: Draw your crop rectangle on top of the image using your mouse",
		"FaqQ3Ans5": "Step 5: Click \"Apply\" to crop photo",
		"ResizeImage": "Resize Image",
		"ResizeImagePara": "Simply upload an image to our image resizer and specify exact pixel dimensions you want to resize your image to. You can also resize images to a percentage of the original size. This resize tool is useful if you want to use your images in forums, blogs, social media or profile photos. You can resize images in following units pixels, inches, cm, or mm.",
		"CropImage": "Crop Image",
		"CropImagePara": "ImageResize.org also allows you to crop images. When cropping a photo, you can choose to keep the original aspect ratio by locking aspect ratio. Alternatively, you can select different aspect ratios such as 1:1 or 16:9 for your crop. You can also flip images (horizontally or vertically) or rotate them.",
		"ReduceImageSize": "Reduce Image Size",
		"ReduceImageSizePara": "Our image resizer allows you to limit image file size in Kb or Mb. Simply select “Custom File Size” option under “Optimize” settings. Then enter your target file size in Kilobytes or Megabytes. This feature is useful if you are emailing your photos or if you have some file size restrictions when uploading images (blogs, forums). While our image resizer allows basic optimizations, you may want to use our advanced <a href=\"/compress-images\">image compressor</a> for png and jpg compressions.",
		"ChangeAspectRatio": "Change Aspect Ratio",
		"ChangeAspectRatioPara": "When resizing images, you can choose to keep original aspect ratio or change it as you wish. Note: changing an image’s aspect ratio may distort (stretch) the image. If you wish to change the aspect ratio without stretching the image, you may wish to use our “background color fill” option. If this option is selected, we will resize your image and fill it with your choice of background color to avoid stretching.",
		"SimpleFast": "Simple and Fast",
		"SimpleFastPara": "ImageResize.org is hosted in a scalable cloud computing environment. As a result, we can quickly resize images regardless of server load. This means you do not have to wait for a queue. This image resizer is simple and intuitive to use with live resize calculations for your final image size.",
		"FreeSecure": "Free & Secure",
		"FreeSecurePara": "This tool is free and always will be. We automatically delete your image files after 24 hours from our servers for security and privacy reasons (unless you choose to host the image with us). Other benefits: super fast, easy to use, and mobile-friendly."
	},
	"BulkResize": {
		"PageHeader": "Batch Image Resize Tool",
		"PageHeaderDescription": "Resize, compress, or convert multiple images at once",
		"FirstH2": "What is Batch Image Resize Tool?",
		"FirstPara": "Imageresize.org provides a bulk/batch resizing tool to easily Resize, compress, or convert multiple images at once. It is an online tool, so there is no software to download or install. You can upload up to 20 images at once using the upload box above.",
		"Batchimageresize": "Batch image resize",
		"BatchimageresizePara": "Upload multiple photos from the upload box above to start resizing them. You can resize all your photos as a percentage of the original size or specify exact width and height.",
		"BulkImageCompressor": "Bulk image compressor",
		"BulkImageCompressorpara": "Upload multiple images and compress them all at once using our image editor. You can choose a compression level or simply specify the maximum file size you want.",
		"WhatBulkTool": "What is different in Bulk Tool?",
		"WhatBulkToolPara": "Batch resize tool is designed to process multiple images at once. At this time, the bulk tool does not allow single image editing (crop, flip, rotate, and image filters).",
		"BulkImageConverter": "Bulk image converter",
		"BulkImageConverterPara": "Need to convert multiple images? Our image editor allows you to convert your images to any of the following file types; jpg, png, gif, and bmp."
	},
	"CompressImages": {
		"PageHeader": "Easily Compress Images Online",
		"PageHeaderDescription": "Advanced PNG and JPEG compressor for reducing file size without quality loss",
		"WhatImageCompressor": "What is an Image Compressor?",
		"JPEGCompressor": "JPEG compressor",
		"WhatImageCompressorPara": "It is a free online tool provided by ImageResize.org for compressing images without losing image quality. We use the latest image compression methods and intelligent algorithms to lower your image file size. This image compressor can compress JPG and PNG images. If you have a GIF file to optimize, we recommend GIF Compressor by GIFmaker.net",
		"JPEGCompressorPara": "JPEG is a popular file/compression format used for storing digital images. Most JPEG files can be optimized further without losing any visual image quality. Upload and compress JPEG files above to improve page load times and save your bandwidth costs.",
		"PNGCompressor": "PNG compressor",
		"PNGCompressorPara": "PNG compresses images while keeping original data (lossless). As a result, file size can be bigger. Our compressor applies lossy algorithms, strip unwanted data, converts 24-bit color index to 8-bit. The Result is a drastically lower PNG image size with the same image quality.",
		"ImageOptimizationForWebmasters": "Image optimization for webmasters",
		"ImageOptimizationForWebmastersPara": "If you are a webmaster, you want your pages to load faster to provide the best user experience. Optimizing your images will lead to faster page loading, save bandwidth, and help your website rank higher in search results.",
		"ImagesOptimization": "Images optimization for consumers",
		"ImagesOptimizationPara": "If you are a consumer or a photographer, you may want to compress your images to upload them faster. Optimized images also help to stay within file size restrictions on many consumer websites."
	},
	"PdfCompressor": {
		"PageHeader": "PDF Compressor - Easily Compress PDF Online",
		"PageHeaderDescription": "Advanced PDF compressor for reducing file size without quality loss",
		"HowReducePDF": "How to Reduce PDF File Size?",
		"AnsDesc": "In this section, we will explain all the steps that are required to compress a PDF file without losing quality:",
		"Ans1": "1.Click the \"Choose PDF\"button in the upload box (you can also drag and drop multiple PDF files for batch compressing).",
		"Ans2": "2.Click on the blue \"Compress PDF\"button once you have selected all the PDFs you want to compress.",
		"Ans3": "3.Observe the status of each PDF file as it changes from Uploading > Compressing > Done. The results table will list the PDF file size reduction and percentage size saved next to each PDF file.",
		"Ans4": "4.Download compressed PDF files individually by clicking on the blue download arrow next to each file.",
		"Ans5": "5.To download all files in ZIP format, click the \"Download All\"blue button (below the file table)",
		"WithoutLosingQuality": "Compress PDF Without Losing Quality",
		"WithoutLosingQualityPara": "We understand that quality matters when dealing with PDF files because PDFs are often zoomed, printed, and contain graphs and figures. When compressing your PDF files we pay attention to quality and do our best to reduce file size without losing quality. Our advanced algorithm can determine the components of your PDFs such as objects, images, and their current compression levels and resolution. We then apply our compression algorithm only if we believe that doing so will not degrade the quality of these components.",
		"CompressPDFOnline": "Compress PDF Online",
		"CompressPDFOnlinePara": "Our PDF compressor is 100% free and it operates entirely on the cloud. This means you do not need to install any software to compress your PDF files. Whether you are looking for a PDF compressor for mac, windows, or mobile devices, this tool can make your pdf smaller. We also remove all PDF files from our servers after 12 hours for security and privacy.",
		"AdvancedPDFCompressor": "Advanced PDF Compressor",
		"AdvancedPDFCompressorPara": "We reduce PDF size by performing several optimization techniques. For example, if your PDF file is image heavy, this compressor will determine the current resolution of those images and compress them even further using the JPEG or JBIG2 lossless compression method while preserving quality. We also discard alternate and duplicate images along with page thumbnails to reduce PDF size further. Other optimizations may include: removing embedded fonts from PDF file (only when PDF contain common fonts), optimizing content streams (we use Flate compression method), and removing duplicate fonts and color profiles."
	},
	"PdfResize": {
		"PageHeader": "PDF Resizer - Easily Resize PDF Files Online",
		"PageHeaderDescription": "Resize your PDF files to a new paper size by uploading them below.",
		"HowToResize": "How to Resize PDF?",
		"Ans1": "Click the \"Choose PDF\" button in the upload box (you can also drag and drop multiple PDF files for batch resizing).",
		"Ans2": "Click on the \"Proceed to PDF Resize\" button.",
		"Ans3": "In \"Select Paper Size\" section, select a paper size or enter custom width and height.(you can enter a custom size in millimeters, points, inches, or pixels)",
		"Ans4": "Choose \"Scale to fit\"if you want to scale PDF content to fit the new paper size",
		"Ans5": "Choose \"Keep aspect ratio\" if you want to keep the aspect ratio of the original PDF while scaling.",
		"Ans6": "Click the \"Resize PDF\" button",
		"Ans7": "Click \"Download All\" button to download the resized PDF(s)",
		"ResizePDFOnline": "Resize PDF Online",
		"ResizePDFOnlinePara": "This PDF resizer is an online tool. That means no software to install. It will work on your windows, mac, or mobile devices. This tool is 100% free, has no file limits, and does not require registration."
	},
	"CropImages": {
		"PageHeader": "Crop Photos Using Our Image Editor",
		"PageHeaderDescription": "Create better compositions, remove unwanted parts, or get the aspect ratio right",
		"CreateBetterCompositions": "Create better compositions",
		"CreateBetterCompPara1": "ImageResize.org’s online photo cropper lets you crop your images to fit the perfect composition and get rid of unwanted areas from your photo.",
		"CreateBetterCompPara2": "Sometimes it is important to capture the moment than to worry about composition. The photographic moments happens so fast and you probably don’t have time to decide what to include in the frame. Need not worry, our photo cropper lets you crop your images using a specific aspect ratio, exact dimensions, or simply drag and crop.",
		"CropFreeStyleUseAnAspect": "Crop freestyle or use an aspect ratio",
		"CropFreeStyleUseAnAspectPara1": "Sometimes your photos need to be cropped to a certain aspect ratio to be able to properly displayed. Most social media sites such as Pinterest and Facebook or even smart TVs would stretch and distort your images if they are not properly cropped to fit the aspect ratio best practices set by those sources.",
		"CropFreeStyleUseAnAspectPara2": "Our image cropper has built-in aspect ratio button to help you easily apply an aspect ratio to your crop. You can also crop it freestyle if you choose to do so.",
		"HowToCropPhoto": "How to crop a photo",
		"HowToCropPhotoAns": "Follow these simple 4 step process to start cropping your photo",
		"Step1Para": "Upload your photo to the single image editor",
		"Step2Para": "Select the crop option under \"Image Adjust\" step",
		"Step3Para": "Select a crop area or a pre-configured aspect ratio and click \"Apply”",
		"Step4Para": "Click \"Resize Image\" to generate the cropped version of your image"
	},
	"PhotoEditor": {
		"PageHeader": "A Simple Image Editor Without Complexity",
		"PageHeaderDescription": "Add filters, crop, resize, or flip & rotate your images with ease",
		"PhotoFiltersWithEase": "Apply photo filters with ease",
		"PhotoFiltersWithEasePara1": "Sometimes your photos need an extra boost to bring out the colors and add that wow factor. Our photo editor allows you to add a variety of preconfigured filters to bring out the best in your photos.",
		"PhotoFiltersWithEasePara2": "Whether you are looking to give your photo a Retro or a Light leak look, we have got your covered with more than 15 photo filters.",
		"AdjustPhotParameter": "Adjust your photo parameters",
		"AdjustPhotParameterPara": "No matter how advanced your camera is, sometimes your photos still need a post-processing boost to bring out the details of the photo. You can use the Image Editor to adjust things like Brightness, Contrast, and saturation of your photos.",
		"CropFlipRotateImages": "Crop, flip, or rotate images",
		"CropFlipRotateImagesPara1": "Sometimes your photo compositions don’t come out the way you want them. Our Image Editor let you get rid of unwanted areas in your photos using the Photo Cropper. ",
		"CropFlipRotateImagesPar2": " You can also apply an aspect ratio to your crop to make sure your photo perfectly fit social media sites and display devices without having to stretch.",
		"CropFlipRotateImagesPar3": " You can also flip or rotate your images.",
		"SimpleToUse": "It is super simple to use",
		"SimpleToUsePara1": "Image editing doesn’t have to be a rocket science. We built our editor with ease of use in mind. Editing a photo for the correct style and adjusting it to your artistic needs shouldn’t take more than 10 seconds",
		"SimpleToUsePara2": "!Give it a try and you will love the simplicity of our Image editor. We support both mobile and Desktop users, so give it a try regardless of your device.",
		"HowToEditPhoto": "How to edit a photo",
		"HowToEditPhotoAns": "Follow these simple 4 step process to edit your photos",
		"Step1Para": "Upload your photo to the image editor",
		"Step2Para": "Select the editing functions from the \"Image Adjust\"section of our editor",
		"Step3Para": "Optimize or resize the image is desired",
		"Step4Para": "Click \"Resize Image\"to download the edited version of your image"
	},
	"PhotoCompress": {
		"PageHeader": "Compress JPEG and PNG Images Without Losing Quality",
		"PageHeaderDescription": "Optimize your images to reduce file size while keeping image quality",
		"FirstHeader": "Optimizing is no longer optional",
		"FirstPara1": "If your pages load slow, it is probably caused by uncompressed images. The problem is grave enough for Google to use page load time as a ranking factor now.",
		"FirstPara2": "Optimizing your images properly lower your load time, reduce bounce rate, and save both your and customer’s data costs. So there is really no reason to upload an image to your website without optimizing it!",
		"SecHeader": "State of the art JPEG compression",
		"SecPara1": "JPEG is the most used image format on the world wide web. This is because it uses a lossy (irreversible) compression algorithm. However, most of the JPEG images you produced by digital cameras or download from the web are not compressed to the full extent.",
		"SecPara2": "This is where our intelligent JPEG Compressor come to the rescue. It allows you to save as much as 90% of the original file size without losing visible image quality.",
		"ThirdHeader": "State of the art PNG compression",
		"ThirdPara1": "PNG is another image format that is widely used. Compared to JPEG, PNG uses a lossless (reversible) compression algorithm. This means it stores extra data to be able to reverse the image to its original quality. Such extra data, however, bloat the file size.",
		"ThirdPara2": "Our PNG Compressor applies a lossy compression algorithm and removes extra metadata. The result is a drastically reduced PNG files size without losing image quality.",
		"FourthHeader": "Bulk image compression",
		"FourthPara": "Want to compress all your images at once? No problem. Simply drag and drop or select your images to our bulk image compressor and it will automatically start compressing them.",
		"HowToCompressPhoto": "How to compress a photo",
		"HowToCompressPhotoAns": "Follow these two steps to compress single or bulk images",
		"Step1Para": "Upload your photos to the image compressor",
		"Step2Para": "Click Download Images button to get a zip file with all your compressed images"
	},
	"View": {
		"PageHeader": "View Image, edited with ImageResize.org",
		"PageHeaderDescription": "This image was resized & compressed via ImageResize.org, best online image resizer",
		"ReportCauseQuestion": "Please select a category which best describes why you are reporting this image. Once your report is submitted, we will review the contents of the image and remove it if necessary.",
		"AdultOrIllegalContent": "Adult or Illegal Content",
		"SpamContent": "Spam Content",
		"FailedLoadingLink": "Failed to load the image share links, please try again later.",
		"ImageLinks": "Image Links",
		"DirectLink": "Direct Link",
		"HTMLImage": "HTML Image",
		"BBCode": "BBCode",
		"ImageLink": "Image Link",
		"DeleteLink": "Image Delete Link",
		"SavingMsg": "Permanently storing image to our servers...",
		"DeleteHint": "Clicking on this link will remove your image. Save this link if you plan to remove your image later from our servers."
	},
	"HelpPage": {
		"PageHeader": "Help",
		"SingleImagePara1": "How do I resize a single image?",
		"SingleImagePara2": "To resize a JPG or a PNG image, simply upload it to our single image editor here. Once the file is uploaded, you will be taken to our editor where you can select a new size for your image.",
		"MultipleImagePara1": "How do I resize multiple images at once?",
		"MultipleImagePara2": "To resize multiple images at once, you can upload or drag and drop your image files to our bulk resize page. Once your files are uploaded, you can select a new size for your files. New size can be specified as a percentage of original file or as an exact pixel amount."
	},
	"PrivacyPolicy": {
		"Header": "Privacy policy",
		"Simple": "Our privacy policy is very simple.",
		"Image": "Your images are yours.",
		"Para1": "You own them. When you upload images to ImageResize.org, we temporarily save them on our servers to process them and they are deleted automatically from our servers after 30 minutes - forever. We don't ask you for any other private information.</p><p>If you choose to post the resized images to Facebook directly from ImageResize.org, and give us permission by connecting through Facebook, then we get your email id from Facebook and we store it in our database to keep a track of how many users are making use of the feature. Your email is not shared with anyone. If we ever send you an email, it will come with an unsubscribe link so you can remove yourself form our list.",
		"That is pretty much about it": "That is pretty much about it.",
		"Para2": "By using ImageResize.org, you consent to our privacy policy.",
		"Para3": "We reserve the right to change our privacy policy at any time and in case we decide to change the privacy policy, we will post the changes on this page."
	},
	"TermsOfService": {
		"Header": "Terms of Service",
		"Para1": "By using our website you accept these terms of use, including our",
		"Para2": "If you don’t agree, your remedy is to stop using our website. We may update these terms of use from time to time, so you should revisit each time you use our website.",
		"PrivacyPolicy": "Privacy Policy",
		"EntireAgreement": "Entire Agreement",
		"EntireAgreementPara": "These terms of use forms the entire understanding between you and us with respect to your use of our website.",
		"NoUnlawfulOrProhibitedUse": "No Unlawful or Prohibited Use",
		"NoUnlawfulOrProhibitedUsePara": "As a condition of your use of this website, you warrant that you will not use this website for any purpose that is unlawful or prohibited by these terms of use.",
		"LinksDisclaimer": "Links Disclaimer",
		"LinksDisclaimerPara": "We have no control over the information accessed through links from our site. You use links at your own risk.",
		"Termination/AccessRestriction": "Termination/Access Restriction",
		"Termination/AccessRestrictionPara": "We reserve the right to terminate your access to this website and the related services or any portion of it at any time, without notice.",
		"Disclaimer": "Disclaimer",
		"DisclaimerPara": "Anything contained on this website is provided “as is” without warranty or condition of any kind. While we attempt to ensure that the content of our website is correct, we cannot guarantee its reliability, accuracy or completeness because this information changes all the time. You agree that no information or advice provided by us constitutes medical, legal or financial advice or advice of any other regulated industry and users should not rely exclusively on any such information or advice.",
		"LimitationOfLiability": "Limitation of Liability",
		"LimitationOfLiabilityPara": "We will not be liable to you or any other person or entity for any damages whatsoever arising as a result of your use of this website in any way. In addition, where warranties are implied by law, you acknowledge and agree that the total aggregate liability to us is limited to the total amount paid by you for the particular services that are the subject of the cause of action, even if those services were provided to you without cost.This limitation of liability applies to the fullest extent permitted by law, and shall survive any termination or expiration of this agreement or your use of this website or the services found on this website.",
		"ApplicableLaw": "Applicable Law",
		"ApplicableLawPara": "If any matter concerning this website “ImageResize.org” shall be brought before a court of law, pre- or post-arbitration, viewer, visitor, member, subscriber or customer agrees to that the sole and proper jurisdiction to be the state, city and country of the website owner unless otherwise here specified. In the event that litigation is in a federal court, the proper court shall be the closest federal court to the web site owner’s address.",
		"Copyright": "Copyright",
		"CopyrightPara": "All contents of this website are copyright by ImageResize.org. Unless otherwise specified, we own or are licensed to use the copyright in all material on our website. Please contact us should you require permission to reproduce any of the contents of this site. We may or may not be able to authorise use, particularly of trademarks or materials of other companies.Only your personal use of our copyright materials is permitted, which means that you may access, download, or print such materials for your personal use only. Commercial use of any sort is expressly prohibited.",
		"MaterialConnectionDisclosure": "Material Connection Disclosure:",
		"MaterialConnectionDisclosurePara": "We may promote products or services offered by other individuals or businesses and we may be paid affiliate commissions on any purchase you make. You will not be required to purchase anything we recommend. You should always perform your own due diligence before purchasing a product or service mentioned on this website ImageResize.org.All recommendations are made in good faith based upon the opinion of the writer at the time a product or service is mentioned on the website.",
		"ServiceContact": "Service Contact:",
		"Imageresize.org@gmail.com": "imageresize.org@gmail.com"
	},
	"Report": "Report",
	"Image Resizer": "Image Resizer",
	"Bulk Resize": "Bulk Resize",
	"Image Compressor": "Image Compressor",
	"PDF Tools": "PDF Tools",
	"PDF Compressor": "PDF Compressor",
	"PDF Resizer": "PDF Resizers",
	"Convert Tools": "Convert Tools",
	"JPG TO PDF": "JPG TO PDF",
	"JPG TO PNG": "JPG TO PNG",
	"PDF TO JPG": "PDF TO JPG",
	"PDF TO PNG": "PDF TO PNG",
	"PNG TO JPG": "PNG TO JPG",
	"PNG TO PDF": "PNG TO PDF",
	"Features": "Features",
	"Photo Cropping": "Photo Cropping",
	"Photo Editing": "Photo Editing",
	"Photo Compressing": "Photo Compressing",
	"Image Tools": "Image Tools",
	"Image Resize": "Image Resize",
	"About": "About",
	"Contact": "Contact",
	"Help": "Help",
	"Feedback": "Feedback",
	"Legal": "Legal",
	"Privacy": "Privacy",
	"Terms of Service": "Terms of Service",
	"The images could not be converted:": "The images could not be converted:",
	"Images will be automatically removed from servers after 24 hrs.": "Images will be automatically removed from servers after 24 hrs.",
	"Note:": "Note:",
	"Download Image": "Download {num, plural, =0 {Image}  other {Images}}",
	"GIF From Images": "GIF From Images",
	"Resize your Images": "Resize your Images",
	"Optimize Your Image (optional)": "Optimize Your Image (optional)",
	"Save Image As": "Save Image As",
	"Resize Image": "Resize {num, plural, =0 {Image}  other {Images}}",
	"Proceed to Bulk Resize": "Proceed to Bulk Resize",
	"The image could not be resized:": "The image could not be resized:",
	"Compress Images": "Compress Images",
	"Download All": "Download All",
	"Tweet Your Savings": "Tweet Your Savings",
	"Contact | ImageResize.org": "Contact | ImageResize.org",
	"Delete Image | ImageResize.org": "Delete Image | ImageResize.org",
	"Help | ImageResize.org": "Help | ImageResize.org",
	"Adjust Image (Optional)": "Adjust Image (Optional)",
	" Resize your Image": " Resize your Image",
	"Failed to save the image, please try again later.": "Failed to save the image, please try again later.",
	"Image Saved Permanently": "Image Saved Permanently",
	"Convert to JPG": "Convert to JPG",
	" Convert to PNG": " Convert to PNG",
	"Save Your Image": "Save Your Image",
	"ContextMenuItem": "This image will be deleted soon. Click \"Download Image\" to save it.",
	"Note": "Note: Image will be removed soon. Click \"Save to Web\" button to get a permanent link to the image. You can also ",
	"You can": "You can",
	"re-edit": "re-edit",
	"this image.": "this image.",
	"Save to Disk": "Save to Disk",
	"Save to Web": "Save to Web",
	"Convert to PDF": "Convert to PDF",
	"PDF could not be resized:": "PDF could not be resized:",
	"For PDF files, please use our": "For PDF files, please use our",
	"page": "page",
	"This page support one image at a time.": "This page support one image at a time.",
	"For bulk edits, please use ": "For bulk edits, please use ",
	"Bulk Resize page": "Bulk Resize page",
	"Log | ImageResize.org": "Log | ImageResize.org",
	"Compress PDF": "Compress PDF",
	"The pdf could not be resized:": "The pdf could not be resized:",
	"Privacy Policy | ImageResize.org": "Privacy Policy | ImageResize.org",
	"Terms of Service | ImageResize.org": "Terms of Service | ImageResize.org",
	"Failed to report the image, please try again later.": "Failed to report the image, please try again later.",
	"Okay": "Okay",
	"Successfully reported the image.": "Successfully reported the image.",
	"Embed This Image": "Embed This Image",
	"Copy & Paste this code in your HTML": "Copy & Paste this code in your HTML",
	"Bulk Image Resize": "Bulk Image Resize",
	"Select Paper Size": "Select Paper Size",
	"Scale (Optional)": "Scale (Optional)",
	"Resize PDF": "Resize PDF",
	"The pdf files could not be converted:": "The pdf files could not be converted:",
	"Your PDF files Are Ready": "Your PDF files Are Ready",
	"Note:(PdfDownload)": "Note:",
	"PDF files will be automatically removed from servers after 24 hrs.": "PDF files will be automatically removed from servers after 24 hrs.",
	"Download All PDFs (Zip)": "Download All PDFs (Zip)",
	"Proceed to PDF Resize": "Proceed to PDF Resize",
	"This image was saved by a user via ImageResize.org": "This image was saved by a user via ImageResize.org",
	"Share Links": "Share Links",
	"Report Image": "Report Image",
	"Apply": "Apply",
	"Reset": "Reset",
	"Loading...": "Loading...",
	"Flip Horizontally": "Flip Horizontally",
	"Flip Vertically": "Flip Vertically",
	"Rotate 90 CW": "Rotate 90 CW",
	"Rotate 90 CCW": "Rotate 90 CCW",
	"Ready": "Ready",
	"Done": "Done",
	"Uploading": "Uploading",
	"Compressing": "Compressing",
	"Archiving": "Archiving",
	"Error": "Error",
	"Max File Size": "Max File Size",
	"(Optional)": "(Optional)",
	"Or Choose a Max File Size": "Or Choose a Max File Size",
	"No Change": "No Change",
	"Add more URLs": "Add more URLs",
	"Up to": "Up to",
	"Computer": "Computer",
	"URL": "URL",
	"Drag ": "Drag ",
	"here": "here",
	"INSERT": "INSERT",
	"URL HERE:": "URL HERE:",
	"Select DPI (optional)": "Select DPI (optional)",
	"Fill Background (optional)": "Fill Background (optional)",
	"Black": "Black",
	"White": "White",
	"Custom": "Custom",
	"Transparent": "Transparent",
	"Unit": "Unit",
	"Image Size": "Image Size",
	"Not Found": "Not Found",
	"or, if u prefer": "or, if u prefer",
	"Drag PDFs here": "Drag PDFs here",
	"Drag PDF here": "Drag PDF here",
	"Drag Images here": "Drag Images here",
	"Drag Image here": "Drag Image here",
	"Resize": "Resize",
	"25% Smaller": "25% Smaller",
	"50% Smaller": "50% Smaller",
	"75% Smaller": "75% Smaller",
	"Custom Size": "Custom Size",
	"percent": "percent",
	"pixels": "pixels",
	"inch": "inch",
	"cm": "cm",
	"mm": "mm",
	"DPI": "DPI = Dots per inches. If you specify image size in mm, cm, or inches, we will store the DPI information in image metadata (JPG only). So that your printers can print at the specified size. If unsure, leave at default.",
	"Your images will be ready in just a few seconds.": "Your images will be ready in just a few seconds.",
	"Width": "Width",
	"Height": "Height",
	"Lable": "Lable",
	"Resize By page Size": "Resize By page Size",
	"Custom page Size": "Custom page Size",
	"Scale to fit page": "Scale to fit page",
	"Keep aspect ratio (proportions) intact": "Keep aspect ratio (proportions) intact",
	"Selecting this option fit your PDF to new page size. Recommended.": "Selecting this option fit your PDF to new page size. Recommended.",
	"Scale your PDF to fit new page size while keeping aspect ratio. Recommended.": "Scale your PDF to fit new page size while keeping aspect ratio. Recommended.",
	"Has ImageResize helped you? you can help us too!": "Has ImageResize helped you? you can help us too!",
	"Crop": "Crop",
	"Flip": "Flip",
	"Rotate": "Rotate",
	"Filters": "Filters",
	"Adjust": "Adjust",
	"Custom Percentage": "Custom Percentage",
	"Up to 20 PDFs": "Up to 20 PDFs",
	"Up to 20 Images": "Up to 20 Images",
	"INSERT PDFs URL HERE": "INSERT PDFs URL HERE",
	"INSERT Image URL HERE": "INSERT IMAGE URL HERE",
	"Compress PDFs to start compressing": "Compress PDFs to start compressing",
	"Compress images to start compressing": "Compress images to start compressing",
	"Choose Images to Resize": "Choose Images to Resize",
	"Choose an Image to Resize": "Choose an Image to Resize",
	"Choose PDF files to Resize": "Choose PDF files to Resize",
	"Choose a PDF to Resize": "Choose a PDF to Resize",
	"Choose Images to Compress": "Choose Images to Compress",
	"Choose PDFs to Compress": "Choose PDFs to Compress",
	"Save & Download Image": "Save & Download {num, plural, =0 {Image}  other {Images}}",
	"Or link to us": "Or link to us",
	"Original": "Original",
	"1:1": "1:1",
	"4:3": "4:3",
	"16:9": "16:9",
	"3:2": "3:2",
	"2:1": "2:1",
	"150 (Default)": "150 (Default)",
	"Choose optimization level": "Choose optimization level",
	"Best Image Quality": "Best Image Quality",
	"Good Image Quality": "Good Image Quality",
	"Average Image Quality": "Average Image Quality",
	"Original (in px)": "Original (in px)",
	"Cropped": "Cropped",
	"Estimate Final": "Estimate Final",
	"File Name": "File Name",
	"Original Size": "Original Size",
	"Size": "Size",
	"Original (px)": "Original (px)",
	"New Size": "New Size",
	"New (px)": "New (px)",
	"Copied!": "Copied!",
	"Copy": "Copy",
	"Status": "Status",
	"Action": "Action",
	"Old Size": "Old Size",
	"Image Size Info": "Image Size Info",
	"01": "01",
	"02": "02",
	"03": "03",
	"04": "04",
	"Resize Settings": "Resize Settings",
	"Your Images Are Ready": "Your Images Are Ready",
	"We will attempt to make your image smaller than this size. This feature does not work for PNG files": "We will attempt to make your image smaller than this size. This feature does not work for PNG files",
	"Original image expired, please re-upload to edit": "Original image expired, please re-upload to edit",
	"Current Page Size": "Current Page Size",
	"File Size": "File Size",
	"Remove": "Remove",
	"Get Started": "Get Started",
	"MP3 Cutter": "MP3 Cutter"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 932
// module chunks = 0